
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContext/AuthProvider";

const AdminPrivateRoute = ({ children }) => {
    const { authUser } = useContext(AuthContext);
    const location = useLocation();

    if (!authUser) {
        return (
            <Navigate
                to="/"
                state={{ from: location }}
                replace
            />
        );
    }

    if (authUser?.role === "agent") {
        return (
            <Navigate
                to="/agent/dashboard"
                state={{ from: location }}
                replace
            />
        );
    }

    if (authUser?.role !== "admin") {
        return (
            <Navigate
                to="/unauthorized"
                state={{ from: location }}
                replace
            />
        );
    }

    return children;
};

export default AdminPrivateRoute;
